export const LEAD_MAGNET_TYPES = [
  { value: "mini-guide", label: "Mini-Guide", description: "3-5 page narrative guide" },
  { value: "checklist", label: "Checklist", description: "Actionable items with explanations" },
  { value: "framework", label: "Framework", description: "Named system with steps" },
  { value: "swipe-file", label: "Swipe File", description: "Templates and scripts to steal" },
  { value: "script", label: "Script", description: "Word-for-word delivery guide" },
  { value: "assessment", label: "Assessment / Quiz", description: "Diagnostic with scoring" },
];

export const LEAD_MAGNET_TONES = [
  "Direct", "Practical", "Insightful", "Calm", "Authoritative", "Warm", "Conversational",
];

export const LEAD_MAGNET_LOADING_MESSAGES = [
  "Building the structure...",
  "Writing the opening...",
  "Developing each section...",
  "Adding the quick wins...",
  "Crafting the next step...",
  "Polishing the full document...",
];
